import { client } from '../client';
import { CareAdvisorProfile, UserProfile } from './types/UserProfile';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export const saveCareAdvisorProfile = async (
  payload: CareAdvisorProfile,
  user_id: number,
  userRole?: string,
): Promise<UserProfile> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.patch<UserProfile>(`${prefix}/users/${user_id}/care_advisor_profile`, payload);

  return data;
};
